import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-nav-search',
  templateUrl: './nav-search.component.html',
  styleUrls: ['./nav-search.component.scss']
})
export class UserNavSearchComponent implements OnInit {
  public isSearch: boolean;
  constructor() {
    this.isSearch = false;
  }

  ngOnInit() { }

}
